<template>
  <div class="ka-pc-time-spans">
    <button
      v-for="ts in timeSpans"
      :key="ts.key"
      :class="['ka-pc-ts-btn', { active: activeTimeSpan === ts.key }]"
      @click="$emit('timespan', ts.key)"
    >{{ ts.label }}</button>
    <div class="ka-pc-slider-area" v-if="maxIndex > 0">
      <div class="ka-pc-slider-track">
        <input
          type="range"
          class="ka-pc-range ka-pc-range-min"
          min="0"
          :max="maxIndex"
          :value="sliderStart"
          @input="$emit('update:sliderStart', Number($event.target.value))"
          @mousedown="$emit('slidestart')"
          @mouseup="$emit('slideend')"
          @touchstart="$emit('slidestart')"
          @touchend="$emit('slideend')"
        />
        <input
          type="range"
          class="ka-pc-range ka-pc-range-max"
          min="0"
          :max="maxIndex"
          :value="sliderEnd"
          @input="$emit('update:sliderEnd', Number($event.target.value))"
          @mousedown="$emit('slidestart')"
          @mouseup="$emit('slideend')"
          @touchstart="$emit('slidestart')"
          @touchend="$emit('slideend')"
        />
      </div>
      <span class="ka-pc-slider-label">{{ t.sliderLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeSpanBar',
  props: {
    t: { type: Object, required: true },
    timeSpans: { type: Array, required: true },
    activeTimeSpan: { type: String, required: true },
    sliderStart: { type: Number, required: true },
    sliderEnd: { type: Number, required: true },
    maxIndex: { type: Number, required: true }
  }
}
</script>
